export default __webpack_public_path__ + "static/media/captur-colour-7.1ffaa2cd.jpg";